import { useSuspenseQuery } from '@apollo/client'
import {
  GetNestedProjectDocument,
  GetNestedProjectQuery,
  GetNestedProjectQueryVariables,
  GetShareListItemDocument,
  GetShareListItemQuery,
  GetShareListItemQueryVariables,
} from '@sketch/gql-types'
import { StorageItemIdentity } from '../types'

export const useGetStorageItem = (item: StorageItemIdentity) => {
  const responseShare = useSuspenseQuery<
    GetShareListItemQuery,
    GetShareListItemQueryVariables
  >(GetShareListItemDocument, {
    variables: { shareIdentifier: item.identifier },
    skip: item.__typename !== 'Share',
    fetchPolicy: 'cache-first',
  })

  const responseProject = useSuspenseQuery<
    GetNestedProjectQuery,
    GetNestedProjectQueryVariables
  >(GetNestedProjectDocument, {
    variables: { projectIdentifier: item.identifier },
    skip: item.__typename !== 'Project',
    fetchPolicy: 'cache-first',
  })

  if (item.__typename === 'Share') {
    return responseShare.data?.share || undefined
  } else {
    return responseProject.data?.project
  }
}
